import React, { Component } from 'react';
import { Icon, Col } from 'antd';
import Slider from 'react-slick';

class ProjectSlider extends Component {
  render() {
    return (
      <Slider {...this.props}>
        <div>
          
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Communication model, 2014</h4>
              <p>Result: Propose a computational model to supervise communication campaigns</p>
              <p>Challenge: Integrate economy and social forecasting with active communication activities</p>
              <p>Team: A team of more than 10 PhD specialists in math, statistics, analysis, forecasting 
              brings a unique model. This allows to plan and supervise a portfolio of government level  communication campaigns</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/commodel.jpg"/></div>
          </Col>
        
        </div>
        
       <div>
          
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Finance integrations, 2015</h4>
              <p>Result: Proposal to manage complexity of organization and software changes across enterprises to support SWIFT ISO 20022 cross-border payments</p>
              <p>Challenge: A number of Enterprises with own Ontology, Metamodels, Registries, Processes and Software to supervise under unified line of changes</p>
              <p>Team: A team of more than 2 PhD specialists brings consultancy for National level Banking and Policy-maker institutions</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/banking.jpg"/></div> 
          </Col>
        
        </div>


        <div>
          
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Data migration and media development, 2016</h4>
              <p>Result: Scrapping, automatic data extraction, data migration, website creation for a public person and a leader of an Israeli right and American conservatives groups</p>
              <p>Challenge: Deployment and security constraints</p>
              <p>Team: A team of 2 specialists</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/israel.jpg"/></div> 
          </Col>
        
        </div>


        <div>
          
          <Col md={10} sm={20}>
            <div className="project">
              <h4>World-scale communication campaigns, 2017 - 2019</h4>
              <p>Result:  Focused crawling, information extraction, network science modelling</p>
              <p>Challenge: More than 12 international multi-languaged markets, more than 10 brand groups with seven digits level USD worldwide export,  unique challenges on realtime collective behavior modelling</p>
              <p>Team: A team of more than 10 PhD multi-disiplinary specialists and 20 IT specialists</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/search.jpg"/></div>
          </Col>
        
        </div>

        <div>  
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Dark web analytics, 2019</h4>
              <p>Result: Collaboration with Evidence-Based Cybersecurity Research Group (US, Atlanta) on a Dark markets research. Data visualization, clustering, trend analysis, instant notification on trend anomalies</p>
              <p>Challenge: Clustering  pipeline of texts with intensive slangs and urban dictionary usage</p>
              <p>Team: A team of 3 researchers</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/darkweb.jpg"/></div>
          </Col>
        
        </div>

        <div>  
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Social physics and network science program, 2016 - 2021</h4>
              <p>Result: Algorithms and models on self-supervised  focused search, collective behaviour modelling with memory effects</p>
              <p>Challenge: Lack of theoretical models and validation data</p>
              <p>Team: A team of 6 math and physics specialists</p>
            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/network.jpg"/></div>
          </Col>
        </div>

    
        <div>
          
          <Col md={10} sm={20}>
            <div className="project">
              <h4>Media VOD and Streaming Platform, 2022</h4>
              <p>Result: Business, Application, and Technical architectures for Video delivery and streaming platform, provided as the C-Level consulting service</p>
              <p>Challenge: Getting outstandingly small latency to compete with current Cloud Media Processing leaders</p>
              <p>Team: A team of 2 specialists</p>

            </div>
          </Col>
           <Col md={10} sm={20} className="mobile-hidden">
            <div className="box"><img src="images/streaming.jpg"/></div>
          </Col>
        
        </div>

      </Slider>
    );
  }
}

export default ProjectSlider;


// WEBPACK FOOTER //
// ./src/Landing/projectSlider.js